import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'
import type { Cost } from '@/stores/type/cost.type'
import { useBaseStore } from '@haskoning/vue-basestore'
import { computed } from 'vue'
import { useAuthorizationStore } from '@/stores/authorization'

const { api } = useApi()
const baseURL = API.CORE.COST.INDEX

export const useCostStore = defineStore('cost', () => {
  const authorizationStore = useAuthorizationStore()
  const canChangeCost = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['change_costunitrates']
    })
  })

  const baseStore = useBaseStore<Cost>({ service: baseURL, api })

  function resetAll() {
    baseStore.reset()
  }

  return {
    ...baseStore,
    canChangeCost,
    resetAll
  }
})
